import * as React from 'react';
import { Route } from 'react-router';
import { makeGetComponent } from './utils';

export const getReferralCodeRoute = () => (
  <Route
    path="invite/:referralCode"
    getComponent={makeGetComponent('ReferralsPage/index')}
  />
);



// WEBPACK FOOTER //
// ./app/routers/ReferralCodeRoute.tsx